import Modal from "react-modal";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import {
  deleteDumpster,
  resetShowDeleteDumpsterConfirmationModal,
  setDumpsterToRemove,
} from "../../dumpstersSlice";
import { ReactComponent as Close } from "../../../../assets/images/close.svg";
import { Oval } from "react-loader-spinner";
import toast from "react-hot-toast";

import "./DeleteDumpsterConfirmationModal.scss";

const modalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#FFFFFF",
  },
};

export const DeleteDumpsterConfirmationModal = () => {
  const dispatch = useAppDispatch();

  const showDeleteDumpsterConfirmationModal = useAppSelector(
    (state) => state.dumpsters.showDeleteDumpsterConfirmationModal
  );
  const deleteDumpsterAPI = useAppSelector(
    (state) => state.dumpsters.deleteDumpster
  );

  const isOpen = showDeleteDumpsterConfirmationModal ? true : false;

  React.useEffect(() => {
    if (!deleteDumpsterAPI.loading && !!deleteDumpsterAPI.error) {
      toast.error("Something went wrong. Please try again.");
    }

    if (
      !deleteDumpsterAPI.loading &&
      !deleteDumpsterAPI.error &&
      deleteDumpsterAPI.value
    ) {
      toast.success("Successfully removed dumpster.");
      dispatch(resetShowDeleteDumpsterConfirmationModal());
    }
  }, [
    !!deleteDumpsterAPI.error,
    !!deleteDumpsterAPI.value,
    !!deleteDumpsterAPI.loading,
  ]);

  const cancelDeletion = () => {
    dispatch(resetShowDeleteDumpsterConfirmationModal());
  };

  const confirmDeletion = () => {
    if (!!showDeleteDumpsterConfirmationModal) {
      dispatch(setDumpsterToRemove(showDeleteDumpsterConfirmationModal.id));
      dispatch(deleteDumpster(showDeleteDumpsterConfirmationModal.id));
    }
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={cancelDeletion} style={modalStyles}>
      <div className="delete-dumpster-modal-container">
        <Close className="close-button" onClick={cancelDeletion} />

        <div className="title">Would you like to proceed?</div>

        <div className="buttons-container">
          <button
            type="submit"
            className="button secondary-button"
            disabled={deleteDumpsterAPI.loading}
            onClick={cancelDeletion}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="button"
            disabled={deleteDumpsterAPI.loading}
            onClick={confirmDeletion}
          >
            Delete
            {deleteDumpsterAPI.loading && (
              <div style={{ marginLeft: 8 }}>
                <Oval
                  color="#131313"
                  height={20}
                  width={20}
                  secondaryColor="#FBD20A"
                />
              </div>
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};
